var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.286,
    height: 14.655,
    viewBox: "0 0 10.286 14.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin",
    d: "M5.126.25a5,5,0,0,1,3.646,1.5,4.916,4.916,0,0,1,1.514,3.629,7.013,7.013,0,0,1-.533,2.46,14.279,14.279,0,0,1-1.29,2.58Q7.706,11.6,6.949,12.652T5.676,14.32l-.55.585q-.206-.206-.55-.619t-1.221-1.6q-.877-1.187-1.565-2.3A15.721,15.721,0,0,1,.55,7.853,6.953,6.953,0,0,1,0,5.376,4.942,4.942,0,0,1,1.5,1.746,4.942,4.942,0,0,1,5.126.25Zm0,6.949a1.815,1.815,0,0,0,1.307-.533,1.787,1.787,0,0,0,0-2.58,1.812,1.812,0,0,0-1.307-.533A1.821,1.821,0,0,0,3.3,5.376,1.82,1.82,0,0,0,5.126,7.2Z",
    transform: "translate(0 -0.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.163c5b741040836a9103a10473fd0fd8.svg";
export { ForwardRef as ReactComponent };